<template>
  <v-container fluid>
    <v-layout wrap justify-start align-content-start>
      <v-flex shrink xs12 md2 lg2 class="mx-2">
        <v-radio-group v-model="round_trip"  @change="setReturn()">
          <v-radio label="ONE-WAY" :value="false"></v-radio>
          <v-radio label="ROUND TRIP" :value="true"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm5 md4 class="mx-2">
        <SelectDepartDate />
      </v-flex>
      <v-flex xs12 sm5 md4 class="mx-2" v-show="round_trip === true">
        <SelectReturnDate :v="v" />
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import Shared from "@/mixins/Shared";
import SelectDepartDate from "@/components/forms/sections/SelectDepartDate.vue";
import SelectReturnDate from "@/components/forms/sections/SelectReturnDate.vue";
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getField"
});

export default {
  name: "DateSelect",
  props: ["v"],
  components: { SelectDepartDate, SelectReturnDate },
  mixins: [Shared],
  computed: {
    ...mapFields([
      "form_fields.round_trip"
    ])
  }
};
</script>
